/**
 * normalizePhone — single source of truth for converting any phone-number
 * representation we encounter in Firestore into Telnyx-required E.164.
 *
 * Why centralize?
 *   Lead/Client docs accumulate phones across years of imports — strings
 *   like "(561) 459-9226", "561-459-9226", "5614599226", "1-561-459-9226",
 *   "+1 561-459-9226" all coexist. Telnyx rejects anything not E.164 with
 *   "destination must be E.164" and the call never starts.
 *
 * Rules (US-centric for now; KRO is single-region):
 *   - Already starts with "+" → trust it (assume caller already E.164).
 *   - 10 digits → prepend "+1".
 *   - 11 digits starting with "1" → prepend "+".
 *   - Anything else → return null (dialing UI will surface a clear error).
 *
 * Stripped before length-checking: spaces, dashes, parentheses, dots.
 */
export function normalizePhone(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;

  // Already E.164 (or close enough — keep the "+" the caller asserted).
  if (s.startsWith('+')) {
    const digits = s.slice(1).replace(/\D/g, '');
    return digits ? `+${digits}` : null;
  }

  const digits = s.replace(/\D/g, '');
  if (!digits) return null;

  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;

  return null; // unknown / malformed
}

export default normalizePhone;
